import React, { Fragment } from 'react'
import FormHelperText from '@material-ui/core/FormHelperText';
import { Typography } from 'components/OptimisedMui'
import StyleSheet from 'styles'

function MemberTitle({required, error, member, children, helperText, hideHelperText, variant = 'h6', onChange, ...props}) {
  return (
    <Fragment>
      <Typography className={styles({error: !!error})} variant={variant} {...props}>{children}{required && <>&nbsp;*</>}</Typography>
      {error && !hideHelperText &&
        <FormHelperText error={true}>{helperText}</FormHelperText>
      }
    </Fragment>
  )
}

const styles = StyleSheet({
  error: {
    color: '#6AAEAA'
  }
})

export default MemberTitle